import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { ArrowLeft } from 'lucide-react';
import { Settings } from 'lucide-react';
import { Server } from 'lucide-react';
import { Plus } from 'lucide-react';
import { Trash2 } from 'lucide-react';
import { RefreshCw } from 'lucide-react';
import { CheckCircle2 } from 'lucide-react';
import { AlertCircle } from 'lucide-react';
import { Loader2 } from 'lucide-react';
import { Store } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { Tooltip } from '@heroui/react';
import MCPMarketplace from '@edusense/ai-chat/components/marketplace/MCPMarketplace';
import { ServerList, ServerItem, EmptyState, ServerStatus, ServerInfo, ServerActions, AddServerForm, FormGroup, Label, Input, TextArea, ErrorMessage, TabNavigation, TabContent } from './MCPSettingsModal.styles';
import styled from '@emotion/styled';
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--theme-paper, #ffffff);
  
  .dark & {
    background-color: var(--theme-paper, #1f2937);
  }
`;
const Header = styled.header`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  background-color: var(--theme-paper, #ffffff);
  flex-shrink: 0;
  
  .dark & {
    background-color: var(--theme-paper, #1f2937);
    border-color: var(--theme-border, #374151);
  }
`;
const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: var(--theme-text, #111827);
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .dark & {
    color: var(--theme-text, #f3f4f6);
  }
`;
const MCPSettingsView = ({ onBack })=>{
    const [servers, setServers] = useState([]);
    const [isAddingServer, setIsAddingServer] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('display');
    const [formData, setFormData] = useState({
        name: '',
        url: '',
        apiKey: '',
        description: ''
    });
    const [formErrors, setFormErrors] = useState({});
    // 글자 크기 상태
    const [fontSizeValue, setFontSizeValue] = useState(()=>{
        const saved = localStorage.getItem('ai-chat-font-size-value');
        return saved ? parseInt(saved) : 14; // 기본값 14px
    });
    // 서버 목록 로드
    useEffect(()=>{
        loadServers();
    }, []);
    // 서버 목록 로드
    const loadServers = ()=>{
        const savedServers = localStorage.getItem('mcp-servers');
        if (savedServers) {
            setServers(JSON.parse(savedServers));
        } else {
            // 기본 서버 설정
            const defaultServers = [
                {
                    id: 'edusense-sse',
                    name: 'Edusense SSE MCP',
                    url: 'https://edusense.ugot.uk/sse',
                    description: 'Edusense 통합 SSE MCP 서버 (DCR OAuth2 지원)',
                    status: 'connected',
                    capabilities: [
                        'edusense',
                        'sse',
                        'real-time',
                        'notifications',
                        'dcr-oauth2'
                    ]
                },
                {
                    id: 'upbit-sse',
                    name: 'Upbit SSE MCP',
                    url: 'https://mcp-upbit.ugot.uk/sse',
                    description: 'Upbit 암호화폐 거래소 SSE MCP 서버 (DCR OAuth2 지원)',
                    status: 'connected',
                    capabilities: [
                        'upbit',
                        'cryptocurrency',
                        'trading',
                        'market-data',
                        'dcr-oauth2'
                    ]
                }
            ];
            setServers(defaultServers);
            // 기본 서버들을 localStorage에 저장
            localStorage.setItem('mcp-servers', JSON.stringify(defaultServers));
        }
    };
    // 서버 저장
    const saveServers = (updatedServers)=>{
        localStorage.setItem('mcp-servers', JSON.stringify(updatedServers));
        setServers(updatedServers);
    };
    // 글자 크기 변경 핸들러
    const handleFontSizeChange = (value)=>{
        const size = Array.isArray(value) ? value[0] : value;
        setFontSizeValue(size);
        localStorage.setItem('ai-chat-font-size-value', size.toString());
        // 이벤트 발생하여 ChatContainer에 알림
        window.dispatchEvent(new CustomEvent('ai-chat-font-size-changed', {
            detail: size
        }));
    };
    // 폼 유효성 검사
    const validateForm = ()=>{
        const errors = {};
        if (!formData.name.trim()) {
            errors.name = '서버 이름을 입력해주세요';
        }
        if (!formData.url.trim()) {
            errors.url = '서버 URL을 입력해주세요';
        } else if (!formData.url.startsWith('mcp://') && !formData.url.startsWith('http')) {
            errors.url = '올바른 URL 형식이 아닙니다 (mcp:// 또는 http(s)://)';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    // 서버 추가
    const handleAddServer = async ()=>{
        if (!validateForm()) return;
        setIsLoading(true);
        const newServer = {
            id: `server-${Date.now()}`,
            name: formData.name,
            url: formData.url,
            apiKey: formData.apiKey,
            description: formData.description,
            status: 'connecting'
        };
        const updatedServers = [
            ...servers,
            newServer
        ];
        saveServers(updatedServers);
        // 연결 테스트 시뮤레이션
        setTimeout(()=>{
            const connectedServer = {
                ...newServer,
                status: 'connected'
            };
            const finalServers = updatedServers.map((s)=>s.id === newServer.id ? connectedServer : s);
            saveServers(finalServers);
            setIsLoading(false);
            setIsAddingServer(false);
            setFormData({
                name: '',
                url: '',
                apiKey: '',
                description: ''
            });
        }, 1500);
    };
    // 서버 삭제
    const handleDeleteServer = (serverId)=>{
        if (window.confirm('이 서버를 삭제하시겠습니까?')) {
            const updatedServers = servers.filter((s)=>s.id !== serverId);
            saveServers(updatedServers);
        }
    };
    // 서버 재연결
    const handleReconnectServer = async (serverId)=>{
        const updatedServers = servers.map((s)=>s.id === serverId ? {
                ...s,
                status: 'connecting'
            } : s);
        saveServers(updatedServers);
        // 재연결 시뮤레이션
        setTimeout(()=>{
            const reconnectedServers = updatedServers.map((s)=>s.id === serverId ? {
                    ...s,
                    status: 'connected',
                    lastError: undefined
                } : s);
            saveServers(reconnectedServers);
        }, 1000);
    };
    // 마켓플레이스에서 서버 설치
    const handleInstallFromMarketplace = async (marketplaceServer)=>{
        const newServer = {
            id: marketplaceServer.id,
            name: marketplaceServer.name,
            url: marketplaceServer.endpoint,
            description: marketplaceServer.description,
            status: 'connecting',
            capabilities: marketplaceServer.capabilities
        };
        const updatedServers = [
            ...servers,
            newServer
        ];
        saveServers(updatedServers);
        // 연결 테스트 시뮤레이션
        setTimeout(()=>{
            const connectedServer = {
                ...newServer,
                status: 'connected'
            };
            const finalServers = updatedServers.map((s)=>s.id === newServer.id ? connectedServer : s);
            saveServers(finalServers);
        }, 1500);
    };
    // 마켓플레이스에서 서버 제거
    const handleUninstallFromMarketplace = async (serverId)=>{
        const updatedServers = servers.filter((s)=>s.id !== serverId);
        saveServers(updatedServers);
    };
    // 상태 아이콘 렌더링
    const renderStatusIcon = (status)=>{
        switch(status){
            case 'connected':
                return /*#__PURE__*/ _jsx(CheckCircle2, {
                    size: 16,
                    className: "text-green-500"
                });
            case 'connecting':
                return /*#__PURE__*/ _jsx(Loader2, {
                    size: 16,
                    className: "text-blue-500 animate-spin"
                });
            case 'error':
                return /*#__PURE__*/ _jsx(AlertCircle, {
                    size: 16,
                    className: "text-red-500"
                });
            default:
                return /*#__PURE__*/ _jsx(AlertCircle, {
                    size: 16,
                    className: "text-gray-400"
                });
        }
    };
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                children: /*#__PURE__*/ _jsxs(TitleRow, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            iconOnly: true,
                            icon: /*#__PURE__*/ _jsx(ArrowLeft, {
                                size: 18
                            }),
                            variant: "ghost",
                            size: "sm",
                            onClick: onBack,
                            label: "뒤로가기"
                        }),
                        /*#__PURE__*/ _jsxs(Title, {
                            style: {
                                flex: 1,
                                marginLeft: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Settings, {
                                    size: 20
                                }),
                                "MCP 설정"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: [
                    /*#__PURE__*/ _jsxs(TabNavigation, {
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                className: activeTab === 'servers' ? 'active' : '',
                                onClick: ()=>setActiveTab('servers'),
                                children: [
                                    /*#__PURE__*/ _jsx(Server, {
                                        size: 16
                                    }),
                                    "내 서버"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: activeTab === 'marketplace' ? 'active' : '',
                                onClick: ()=>setActiveTab('marketplace'),
                                children: [
                                    /*#__PURE__*/ _jsx(Store, {
                                        size: 16
                                    }),
                                    "마켓플레이스"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TabContent, {
                        children: activeTab === 'marketplace' ? /*#__PURE__*/ _jsx(MCPMarketplace, {
                            onInstallServer: handleInstallFromMarketplace,
                            onUninstallServer: handleUninstallFromMarketplace,
                            installedServers: servers.map((s)=>s.id)
                        }) : isAddingServer ? /*#__PURE__*/ _jsxs(AddServerForm, {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    children: "새 서버 추가"
                                }),
                                /*#__PURE__*/ _jsxs(FormGroup, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Label, {
                                            htmlFor: "name",
                                            children: "서버 이름 *"
                                        }),
                                        /*#__PURE__*/ _jsx(Input, {
                                            id: "name",
                                            type: "text",
                                            value: formData.name,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    name: e.target.value
                                                }),
                                            placeholder: "예: GitHub MCP",
                                            error: !!formErrors.name
                                        }),
                                        formErrors.name && /*#__PURE__*/ _jsx(ErrorMessage, {
                                            children: formErrors.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FormGroup, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Label, {
                                            htmlFor: "url",
                                            children: "서버 URL *"
                                        }),
                                        /*#__PURE__*/ _jsx(Input, {
                                            id: "url",
                                            type: "text",
                                            value: formData.url,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    url: e.target.value
                                                }),
                                            placeholder: "mcp://example 또는 https://api.example.com",
                                            error: !!formErrors.url
                                        }),
                                        formErrors.url && /*#__PURE__*/ _jsx(ErrorMessage, {
                                            children: formErrors.url
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FormGroup, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Label, {
                                            htmlFor: "apiKey",
                                            children: "API 키 (선택)"
                                        }),
                                        /*#__PURE__*/ _jsx(Input, {
                                            id: "apiKey",
                                            type: "password",
                                            value: formData.apiKey,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    apiKey: e.target.value
                                                }),
                                            placeholder: "보안을 위해 API 키 입력"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(FormGroup, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Label, {
                                            htmlFor: "description",
                                            children: "설명 (선택)"
                                        }),
                                        /*#__PURE__*/ _jsx(TextArea, {
                                            id: "description",
                                            value: formData.description,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    description: e.target.value
                                                }),
                                            placeholder: "서버에 대한 설명을 입력하세요",
                                            rows: 3
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-2 mt-4",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "primary",
                                            onClick: handleAddServer,
                                            isLoading: isLoading,
                                            disabled: isLoading,
                                            children: "추가"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "secondary",
                                            onClick: ()=>{
                                                setIsAddingServer(false);
                                                setFormData({
                                                    name: '',
                                                    url: '',
                                                    apiKey: '',
                                                    description: ''
                                                });
                                                setFormErrors({});
                                            },
                                            disabled: isLoading,
                                            children: "취소"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex justify-end p-4 border-b border-gray-200 dark:border-gray-700",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "primary",
                                        size: "sm",
                                        leftIcon: /*#__PURE__*/ _jsx(Plus, {
                                            size: 16
                                        }),
                                        onClick: ()=>setIsAddingServer(true),
                                        children: "서버 추가"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(ServerList, {
                                    children: servers.length === 0 ? /*#__PURE__*/ _jsxs(EmptyState, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Server, {
                                                size: 48
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "등록된 MCP 서버가 없습니다"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "primary",
                                                size: "sm",
                                                leftIcon: /*#__PURE__*/ _jsx(Plus, {
                                                    size: 16
                                                }),
                                                onClick: ()=>setIsAddingServer(true),
                                                children: "첫 서버 추가하기"
                                            })
                                        ]
                                    }) : servers.map((server)=>/*#__PURE__*/ _jsxs(ServerItem, {
                                            whileHover: {
                                                scale: 1.01
                                            },
                                            whileTap: {
                                                scale: 0.99
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(ServerStatus, {
                                                    children: renderStatusIcon(server.status)
                                                }),
                                                /*#__PURE__*/ _jsxs(ServerInfo, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h3", {
                                                            children: server.name
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "url",
                                                            children: server.url
                                                        }),
                                                        server.description && /*#__PURE__*/ _jsx("p", {
                                                            className: "description",
                                                            children: server.description
                                                        }),
                                                        server.lastError && /*#__PURE__*/ _jsxs("p", {
                                                            className: "error",
                                                            children: [
                                                                "오류: ",
                                                                server.lastError
                                                            ]
                                                        }),
                                                        server.capabilities && server.capabilities.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                            className: "capabilities",
                                                            children: server.capabilities.map((cap)=>/*#__PURE__*/ _jsx("span", {
                                                                    className: "capability",
                                                                    children: cap
                                                                }, cap))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(ServerActions, {
                                                    children: [
                                                        server.status === 'disconnected' || server.status === 'error' ? /*#__PURE__*/ _jsx(Tooltip, {
                                                            content: "재연결",
                                                            children: /*#__PURE__*/ _jsx(Button, {
                                                                iconOnly: true,
                                                                variant: "ghost",
                                                                size: "sm",
                                                                icon: /*#__PURE__*/ _jsx(RefreshCw, {
                                                                    size: 16
                                                                }),
                                                                onClick: ()=>handleReconnectServer(server.id),
                                                                label: "재연결"
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ _jsx(Tooltip, {
                                                            content: "삭제",
                                                            children: /*#__PURE__*/ _jsx(Button, {
                                                                iconOnly: true,
                                                                variant: "ghost",
                                                                size: "sm",
                                                                icon: /*#__PURE__*/ _jsx(Trash2, {
                                                                    size: 16
                                                                }),
                                                                onClick: ()=>handleDeleteServer(server.id),
                                                                label: "삭제"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, server.id))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default MCPSettingsView;
